import React from "react";
import { useParams } from "react-router-dom";
import { useGetIntegrationsQuery } from "@/store/rest_api";
import SalesforceDetail from "./salesforce/SalesforceDetail";
import HubSpotDetail from "./hubspot/HubSpotDetail";
import PodioDetail from "./podio/PodioDetail";
import GhlDetail from "./ghl/GhlDetail";
import InvestorFuseDetail from "./investorfuse/InvestorFuseDetail";
import ReiSiftDetail from "./reisift/ReiSiftDetail";

export default function IntegrationDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: integrations } = useGetIntegrationsQuery();

  const integration = integrations?.find((item) => item.id === id);

  if (!integration) {
    return <div className="p-4">Integration not found</div>;
  }

  const renderDetail = () => {
    switch (integration.service) {
      case "salesforce":
        return <SalesforceDetail integration={integration} />;
      case "hubspot":
        return <HubSpotDetail integration={integration} />;
      case "podio":
        return <PodioDetail integration={integration} />;
      case "ghl":
        return <GhlDetail integration={integration} />;
      case "investorfuse":
      case "carrot":
        return <InvestorFuseDetail integration={integration} />;
      case "reisift":
        return <ReiSiftDetail integration={integration} />;
      default:
        return <div>Unsupported integration service: {integration.service}</div>;
    }
  };

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">{integration.label}</h1>
        <p className="text-muted-foreground capitalize">{integration.service} Integration</p>
      </div>

      {renderDetail()}
    </div>
  );
}
